import React from 'react';
import './timeLineChart.css';

const TimelineDataCard = ({ dataEvent, handlePageNavigation }: any) => {

    return (
        <>
            {/* Connecting Line and Data Card */}
            {dataEvent.position === 'top' ? (
                <div className='EventDataContainer'>
                    <div className='connectingLine' style={{ top: 'calc(50% - 83px)' }}></div>
                    <div className='connectingDot' style={{ top: 'calc(50% - 85px)' }}></div>
                    <div className='dateBoxContainer' style={{ top: 'calc(50% - 80px)', transform: 'translate(-50%, -130px)' }}>
                        <div className='dataBox'>
                            <div style={{ flexGrow: 1 }} />
                            <div className='title' onClick={handlePageNavigation}>{dataEvent.title}</div>
                            {dataEvent.subtitle && (
                                <div className='subTitle' style={{ marginTop: '4px' }} onClick={handlePageNavigation}>{dataEvent.subtitle}</div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <div className='EventDataContainer'>
                    <div className='connectingLine' style={{ top: 'calc(50% + 13px)' }}></div>
                    <div className='connectingDot' style={{ top: 'calc(50% + 80px)' }}></div>
                    <div className='dateBoxContainer' style={{ top: 'calc(50% + 80px)', transform: 'translate(-50%, 12px)' }}>
                        <div className='dataBox'>
                            {dataEvent.subtitle && (
                                <div className='subTitle' style={{ marginBottom: '4px' }} onClick={handlePageNavigation}>{dataEvent.subtitle}</div>
                            )}
                            <div className='title' onClick={handlePageNavigation}>{dataEvent.title}</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TimelineDataCard;